export default {
  rpa: {
    metadata: {
      title: 'Automatize Tarefas Repetitivas com RPA: soluções eficientes para sua empresa',
      desc: 'Descubra como a RPA pode transformar sua empresa, otimizando processos e aumentando a produtividade da sua equipe. Fale com os nossos especialistas e conheça os benefícios.',
    },
    hero: {
      title: '<span class="font-black">Transforme Seus Processos</span> Repetitivos com Automação Inteligente',
    },
    monthlyPlans: {
      title: '<span class="font-black">Planos mensais</span> para você ter o melhor do RPA!',
      desc: '<span class="font-black">A Robotic Process Automation (RPA)</span>, que em português significa Automação Robótica de Processos, é uma solução que automatiza atividades, faz a sua empresa reduzir custos, permite que o seu time foque em atividades realmente estratégicas e te oferece a possibilidade de contratar o <span class="font-black">serviço de forma mensal.</span><br>Vamos te explicar melhor!',
    },
    whyChooseRpa: {
      title: 'Por que escolher a solução RPA?',
      cards: [
        {
          title: 'Maior Eficiência Operacional:',
          text: 'Automatize tarefas repetitivas e libere o seu time para atividades mais estratégicas, que geram valor real para a sua empresa.',
        },
        {
          title: 'Segurança e Compliance:',
          text: 'Gerencie e controle tarefas de forma unificada e dinâmica, com total segurança e confiabilidade.',
        },
        {
          title: 'Diminuição de Erros e Falhas:',
          text: 'Robôs executando tarefas 24/7 com alto nível de excelência e assertividade.',
        },
        {
          title: 'Redução de Custos:',
          text: 'Reduza tempo e custos operacionais com uma força de trabalho eficiente.',
        },
        {
          title: 'Retorno do Investimento:',
          text: 'ROI atingido a curto prazo com automações que agregam valor à operação.',
        },
        {
          title: 'Melhora da Experiência do Cliente:',
          text: 'Resolva problemas, solicitações e dúvidas de seus clientes de forma mais ágil, contribuindo para a fidelização dos clientes.',
        },
      ],
    },
    featuresOurSolution: {
      title: 'Facilidades da nossa solução',
      list: [
        {
          title: 'Modelo SAAS de atuação:',
          text: 'Com esse modelo, sua empresa não precisa instalar, manter e atualizar hardwares ou softwares. O acesso é fácil e simples, feito apenas por conexão com a internet.',
        },
        {
          title: 'Baixo custo de desenvolvimento: ',
          text: 'Caso a sua empresa não possua um time de TI, não tem problema. Nossa equipe de especialistas faz todo o desenvolvimento e suporte da implantação da plataforma.',
        },
        {
          title: 'Modelo de contratação:',
          text: 'Você adquire o serviço pagando mensalidades. Ou seja, você escolhe quando quer utilizar o serviço ou não.',
        },
        {
          title: 'Adaptável para todos os portes de empresa:',
          text: 'Não importa o tamanho da sua empresa, essa solução atende, com eficiência, todos os tipos.',
        },
        {
          title: 'Sem necessidade de instalação e licenças:',
          text: 'o serviço é contratado apenas quando você quiser utilizar.',
        },
      ],
      button: 'Quero conhecer o RPA',
    },
    rpaImplementation: {
      title: 'Com a nossa implantação RPA você tem:',
      button: 'Transforme sua rotina com RPA',
      cards: [
        {
          icon: 'Icon732',
          title: 'Integração',
          list: [
            'Integração com múltiplas ferramentas, aplicações, sites, Inteligência Artificial e Machine Learning, e qualquer documento digital;',
            'Automatização de qualquer trabalho, a partir da integração nativa com mais de 500 aplicativos;',
            'Possibilita a extração de dados de 3.000 tipos de documentos em mais de 80 idiomas com tecnologias de OCR.',
          ],
        },
        {
          icon: 'Icon730',
          title: 'Estratégia',
          list: [
            'Altamente escalável;',
            'Aquisição como serviço e pagamento mensal pelo uso;',
            'Adaptável a todos os portes de empresas;',
            'Liberação dos funcionários para tarefas mais estratégicas;',
            'Suporte contínuo incluso na mensalidade.',
          ],
        },
        {
          icon: 'Icon728',
          title: 'Segurança',
          list: [
            'Aderente à segurança da informação e LGPD;',
            'Evolução da conformidade e da redução de riscos e fraudes.',
          ],
        },
      ],
    },
    applicable: {
      title: 'Onde o RPA é aplicável?',
      cards: [
        {
          icon: 'icon710',
          title: 'Finanças',
          list: ['Conciliação Contas a Pagar/Receber;', 'Conciliação Bancária;', 'Emissão de Boletos.'],
        },
        {
          icon: 'icon712',
          title: 'Administrativo',
          list: ['Emissão de Notas Fiscais;', 'Captura de Notas Fiscais;', 'Conciliação Bancária.'],
        },
        {
          icon: 'icon723',
          title: 'Saúde',
          list: [
            'Atualização de Planos de Saúde nos portais;',
            'Emissão de Boletos e Relatórios aos clientes;',
            'Controle de Glosa.',
          ],
        },
        {
          icon: 'icon717',
          title: 'Indústria',
          list: ['Registro de Pedidos;', 'Emissão de Registro de Saída;', 'Busca de Licitações.'],
        },
        {
          icon: 'icon714',
          title: 'Logística',
          list: ['Apuração do DRE;', 'Geração de Informações Gerenciais;', 'Acompanhamento de Coletas e Entregas.'],
        },
        {
          icon: 'icon721',
          title: 'Atendimento',
          list: [
            'Busca de informações de Clientes;',
            'Controle de Leads para Atendimento;',
            'Controle de Eficiência no Atendimento.',
          ],
        },
        {
          icon: 'icon725',
          title: 'Jurídico',
          list: ['Baixa de Processos;', 'Baixa de Sinistros;', 'Preenchimento de Contratos.'],
        },
        {
          icon: 'icon719',
          title: 'Compras',
          list: ['Registro de Pedidos;', 'Busca de Clientes;', 'Pesquisa de Preços.'],
        },
      ],
    },
    counterPartnership: {
      title: 'Conte com a <br><span class="font-black">nossa parceria!</span>',
      list: [
        `• <span class="font-black">Time de especialistas em RPA</span> e em outros serviços de tecnologia;`,
        `• <span class="font-black">Mais de 20 anos de experiência</span> no mercado de tecnologia;`,
        `• Criação, manutenção e sustentação de <span class="font-black">robôs feitos exclusivamente para você</span>;`,
        `• <span class="font-black">Custos acessíveis</span> e adaptados para a sua empresa;`,
        `• <span class="font-black">Contratos mensais</span>, otimizando custos;`,
        `• Camadas extras de <span class="font-black">segurança</span>.`,
      ],
    },
    talkToUs: {
      title: 'Estamos prontos para atender a sua necessidade.',
      button: 'Fale com os nossos especialistas!',
    },
  },
}
